<template>
  <div class="custom" style="border: 1px solid #ccc">
    <Toolbar
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      :style="`height: ${parseInt(height) > 230 ? height : '230px'}; overflow-y: hidden`"
      v-model="val"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
    />
  </div>
</template>

<script>
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { upload } from "@/api/upload";
export default {
  components: { Editor, Toolbar },
  props: {
    height: {
      type: String,
      default: "300px",
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请输入内容...",
    }
  },
  data() {
    return {
      editor: null,
      toolbarConfig: {
        excludeKeys: [
          "code",
          "insertLink",
          "emotion",
          "todo",
          "codeBlock",
          "insertVideo",
          "insertImage",
          "fullScreen",
          "lineHeight",
        ],
      },
      editorConfig: {
        placeholder: this.placeholder,
        autoFocus: false,
        uploadImgMaxLength: 1,
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImage,
          },
          uploadVideo: {
            customUpload: this.uploadVideo,
          },
        },
      },
      val: "",
      mode: "default", // or 'simple'
    };
  },
  watch: {
    value(val) {
      this.val = val;
    },
    val(val) {
      if (val && val !== "<p><br></p>") {
        this.$emit("input", val);
      } else {
        this.$emit("input", "");
      }
    },
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor);
      this.val = this.value;
      // console.log(editor.getAllMenuKeys())
    },
    uploadImage(file, insertImgFn) {
      upload(file).then(({ code, msg, result }) => {
        if (code === 0) {
          insertImgFn(result.full_url);
        } else {
          this.$message.error(msg);
        }
      });
    },
    uploadVideo(file, insertVideoFn) {
      upload(file).then(({ code, msg, result }) => {
        if (code === 0) {
          insertVideoFn(result.full_url);
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>